import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { authRouter, publicRouter } from "./Routes/router";
import {
  ProtectedRoute,
  GetLocalStorage,
  PermissionRoute,
} from "./shared/HigherOrderComponent";
import Master from "./shared/Layouts/Master";

const App = () => {
  return (
    <Routes>
      {authRouter.map((route, index) => (
        <Route
          key={route.path}
          path={route.path}
          element={
            <ProtectedRoute>
              {/* <PermissionRoute> */}
              <Master />
              {/* </PermissionRoute> */}
            </ProtectedRoute>
          }
        >
          <Route key={index} path={route.path} element={<route.component />} />
        </Route>
      ))}

      {publicRouter.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          element={
            <GetLocalStorage>
              <route.component />
            </GetLocalStorage>
          }
        />
      ))}

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default App;
